import { render, staticRenderFns } from "./LabComponent.vue?vue&type=template&id=6e33aacd&scoped=true&"
import script from "./LabComponent.vue?vue&type=script&lang=ts&"
export * from "./LabComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LabComponent.vue?vue&type=style&index=0&id=6e33aacd&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e33aacd",
  null
  
)

export default component.exports